import Stack from '@mui/material/Stack';
import SelectionDetailGrid from '../SelectionDetailGrid';
// import palette from '../../../styles/palette';
// import { genderPercentage } from '../../../utils/abdmUtils';

const renderCell = (key, label1, value1) => (
  <SelectionDetailGrid
    key={key}
    label1={label1}
    value1={value1}
    // label2={label2}
    // value2={value2}
    // color={color}
  />
);

const SelectionSummary = ({
  zipCount,
  // averageIncome,
  // averageAge,
  // femaleAudience,
  // maleAudience,
  // otherAudience,
}) => {
  // const [femalePercentage, malePercentage, otherPercentage] = genderPercentage(
  //   femaleAudience,
  //   maleAudience,
  //   otherAudience,
  // );

  return (
    <>
      {zipCount > 0 && (
        <Stack direction="column" spacing={1}>
          {renderCell(
            1,
            'Zip Codes',
            `${zipCount ? zipCount : 0} zips`,
            // 'Female',
            // femalePercentage ? femalePercentage : 0,
            // palette.primary_blue,
          )}
          {/* {renderCell(
            2,
            'Average income',
            averageIncome ? averageIncome : 0,
            'Male',
            malePercentage ? malePercentage : 0,
            palette.light_blue,
          )}
          {renderCell(
            3,
            'Average Age',
            averageAge ? averageAge : 0,
            'Other',
            otherPercentage ? otherPercentage : 0,
            palette.vivid_orange,
          )} */}
        </Stack>
      )}
    </>
  );
};

export default SelectionSummary;
